module.exports = __webpack_public_path__ + "assets/img/4_13.431ce9bd.jpg";